import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { defineMessages, useIntl } from 'react-intl';
import { parse, stringify } from '../../utils/UrlUtil';
import { AccountContext } from '../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../hooks/useSubscriptionExpiredRestrictions';

const i18nMessages = defineMessages({
  addExecutiveReport: { id: 'menu.survey360.add_executiveReport', defaultMessage: 'Add Executive Report' },
});

const ExecutiveReportListTableHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);
  const currentAccount = useContext(AccountContext);
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const { formatMessage } = useIntl();

  const DEFAULT_FILTER_STATE = {
    query: '',
    ...params.filter,
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER_STATE);

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-grid">
      <div className="p-col">
        <div className="p-inputgroup">
          <InputText
            value={filter.query}
            onChange={onChangeQueryText}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onQueryVariableChange();
              }
            }}
          />
          <Button icon="pi pi-search" onClick={onQueryVariableChange} />
        </div>
      </div>
      <div className="p-col align-right">
        <Button
          label={formatMessage(i18nMessages.addExecutiveReport)}
          disabled={subscriptionIsExpired}
          onClick={() => {
            history.push(`/accounts/${currentAccount}/executive-reports/new`);
          }}
        />
      </div>
    </div>
  );
};

export default ExecutiveReportListTableHeader;
